import * as ng from 'angular';

export const UibDatepickerPopupFormat = () => (<angular.IDirective>{

    restrict: 'EAC',

    require: 'ngModel',

    link: (scope: any, elem: JQLite, attrs: any, ngModel: ng.INgModelController) => {
        ngModel.$parsers.push(function toModel(date: any) {
            if (date !== null && date !== undefined) {
                let yyyy = date.getFullYear().toString();
                let mm = (date.getMonth() + 1).toString();
                let dd = date.getDate().toString();
                return yyyy + '-' + (mm[1] ? mm : '0' + mm[0]) + '-' + (dd[1] ? dd : '0' + dd[0]); // padding
            } else {
                return '';
            }
        });
        ngModel.$validators.date = (modelValue, viewValue) => {
            // alert('validate here');
            return true;
        };
    }
});




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/uib-datepicker-popup-format/uib-datepicker-popup-format.directive.ts